var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 39.4286V18.8571C6 18.1333 6.15938 17.4476 6.47812 16.8C6.79687 16.1524 7.2375 15.619 7.8 15.2L21.3 4.91429C22.0875 4.30476 22.9875 4 24 4C25.0125 4 25.9125 4.30476 26.7 4.91429L40.2 15.2C40.7625 15.619 41.2031 16.1524 41.5219 16.8C41.8406 17.4476 42 18.1333 42 18.8571V39.4286C42 40.6857 41.5594 41.7619 40.6781 42.6571C39.7969 43.5524 38.7375 44 37.5 44H30.75C30.1125 44 29.5781 43.781 29.1469 43.3429C28.7156 42.9048 28.5 42.3619 28.5 41.7143V30.2857C28.5 29.6381 28.2844 29.0952 27.8531 28.6571C27.4219 28.219 26.8875 28 26.25 28H21.75C21.1125 28 20.5781 28.219 20.1469 28.6571C19.7156 29.0952 19.5 29.6381 19.5 30.2857V41.7143C19.5 42.3619 19.2844 42.9048 18.8531 43.3429C18.4219 43.781 17.8875 44 17.25 44H10.5C9.2625 44 8.20312 43.5524 7.32187 42.6571C6.44062 41.7619 6 40.6857 6 39.4286Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.2e99c04d.svg";
export { ForwardRef as ReactComponent };